<template>
    <div class="gift-voucher-container">
        <div class="gift-voucher-input-container">
            <input type="text" name="parts" placeholder="AAAAA" :maxlength="partLength" v-model="parts[0]" @keyup="onKeyUp" @paste.prevent="onPaste">
            <span>-</span>
            <input type="text" name="parts" placeholder="BBBBB" :maxlength="partLength" v-model="parts[1]" @keyup="onKeyUp">
            <span>-</span>
            <input type="text" name="parts" placeholder="CCCCC" :maxlength="partLength" v-model="parts[2]" @keyup="onKeyUp">
            <span>-</span>
            <input type="text" name="parts" placeholder="DDDDD" :maxlength="partLength" v-model="parts[3]" @keyup="onKeyUp">
        </div>
    </div>
</template>

<script>
export default {
    name: 'GiftVoucherInput',
    data() {
        return {
            partLength: 5,
            parts: ['', '', '', ''],
        };
    },
    watch: {
        parts: {
            handler() {
                if (!this.parts.every((val) => val.length === this.partLength)) {
                    return;
                }

                this.$emit('code', this.parts.join('-'));
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        onPaste(event) {
            const code = event.clipboardData.getData('text/plain');
            const parts = code.trim().split('-');
            for (let i = 0; i < this.parts.length; i++) {
                this.parts[i] = parts[i];
            }
        },
        onKeyUp(event) {
            const target = event.srcElement || event.target;
            const maxLength = parseInt(target.attributes['maxlength'].value, 10);
            const myLength = target.value.length;
            if (myLength >= maxLength) {
                let next = target;
                while (next.nextElementSibling) {
                    next = next.nextElementSibling;
                    if (next == null)
                        break;
                    if (next.tagName.toLowerCase() === 'input') {
                        next.focus();
                        break;
                    }
                }
            }
            // Move to previous field if empty (user pressed backspace)
            else if (myLength === 0) {
                let previous = target;
                while (previous.previousElementSibling) {
                    previous = previous.previousElementSibling;
                    if (previous == null)
                        break;
                    if (previous.tagName.toLowerCase() === 'input') {
                        previous.focus();
                        break;
                    }
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    .gift-voucher-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .gift-voucher-input-container {
        flex-shrink: 1;

        display: flex;
        flex-direction: row;
        justify-content: center;

        gap: 0.33rem;

        border: 1px solid var(--main-color);
        border-radius: 10px;

        background-color: var(--main-background-light-light);

        padding: 0.375rem 0.75rem;
        line-height: 1.5;

        font-weight: 400;
        font-size: 1.5rem;

        @media (max-width: 450px) {
            font-size: min(1rem, 4vmin);
        }

        @media (max-width: 992px) {
            font-size: min(1.3rem, 4vmin);
        }

        input {
            all: unset;

            box-sizing: content-box;
            width: 6.5ch;
            text-align: center;
        }

        span {
            flex-shrink: 1;
        }
    }
</style>
